import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Bank Accounts initial values
export const bankAccountsInitialValues = {
  accountName: "",
  accountType: "",
  accountNumber: "",
  country: "",
  ownershipType: "",
  bankLocation: "",
}

// Bank Accounts validation schema
export const bankAccountsValidationSchema = Yup.object().shape({
name: Yup.string()
  .required("Bank Name is required")
  .min(3, "Min length: 3 characters")
  .max(100, "Max length: 100 characters")
  .matches(
    /^(?=.*[A-Za-z])(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
    "Enter a valid bank name (must include at least one letter)"
  ),
  purchaseDate: Yup.string().required("Account Opening Date is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Current Balance is required")
    .positive("Must be a positive number > 0")
    .min(1, "Must be greater than 0"), 
  accountName: Yup.string()
    // .required("Account Name is required")
    .matches(
      /^[A-Za-z]+(?: [A-Za-z]+)*$/,
      "Only alphabets allowed. No numbers or special characters. No space at start or end."
    ),
  accountType: Yup.string().required("Account type is required"),
  accountNumber: Yup.string()
    .required("Account number is required")
    .min(3, "Min length: 3 characters")
    .max(50, "Max length: 50 characters")
    .matches(
      /^[A-Za-z0-9\-/]+$/,
      "Allowed: letters, numbers, -, /. No spaces or special characters."
    ),
  // country: Yup.string().required("Country is required"),
  ownershipType: Yup.string().required("Ownership type is required"),
  bankLocation: Yup.string()
    .matches(
      /^\S(?:.*\S)?$/,
      "Space at the beginning or end is not allowed"
    ),
})

/**
 * Bank Accounts Form - Field-only component for AddAssets.js
 * This renders only the bank-accounts-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const BankAccountsForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="bank accounts"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default BankAccountsForm
